import React, { useEffect, useMemo, useState } from "react";

import btnImg from "../../../assets/images/svg/Search.svg";
import totalPOIMg from "../../../assets/images/svg/sales order.svg";
import totalPOIMg2 from "../../../assets/images/svg/totalRfq.svg";
import totalPOIMg3 from "../../../assets/images/svg/Total Bids.svg";
import totalPOIMg4 from "../../../assets/images/svg/confirm order.svg";
import userIcon from "../../../assets/images/svg/user.svg";

import HeaderTitle from "../../../components/common/HeaderTitle/HeaderTitle";
import classes from "../../TabStyles/DashboardTab.module.css";
import DSelectInput from "../../../components/Dashboard/DashboardInputs/DSelectInput";
import DButton from "../../../components/Dashboard/DashboardButtons/Dbutton";
import DDateInput from "../../../components/Dashboard/DashboardInputs/DDateInput";
import { useSelector } from "react-redux/es/hooks/useSelector";
import Reportcard from "../../../components/Dashboard/ReportCards/ReportCard";
import DonutChart from "../../../components/Dashboard/Charts/DonutChart/DonutChart";
import LineChart from "../../../components/Dashboard/Charts/LineChart/LineChart";
import BarChart from "../../../components/Dashboard/Charts/BarChart/BarChart";
import { API_ENDPOINT } from "../../../services/api/resources";
import axios from "axios";
import { emptyCheck } from "../../../utils/validations";
import { weeklyReportObjFormate } from "../../../utils/chartKeyFormat";
import { DASHBOARD_CHART_PALETTES } from "../../../utils/chartColors";
import { useNavigate } from "react-router-dom";

/* ═══════════════════════════════════════════════════════════════════
   UI PRIMITIVES
═══════════════════════════════════════════════════════════════════ */
const SectionPill = ({ title }) => (
  <div style={{
    display: "inline-flex", alignItems: "center",
    background: "#1a4d3a", color: "#fff",
    borderRadius: "20px", padding: "4px 16px",
    fontSize: "16px", fontWeight: 700,
    fontFamily: '"gilroyBold", Inter, sans-serif',
    whiteSpace: "nowrap",
  }}>
    {title}
  </div>
);

const SectionCard = ({ title, children }) => (
  <div style={{
    background: "#fff", borderRadius: "16px",
    border: "1px solid #f0f0f0",
    boxShadow: "0 2px 14px rgba(15,23,42,0.06)",
    padding: "1.1rem 1.25rem", boxSizing: "border-box",
    width: "100%", display: "flex", flexDirection: "column",
    height: "100%", minHeight: "100%", marginBottom: "1.25rem",
  }}>
    <div style={{ marginBottom: "0.85rem" }}>
      <SectionPill title={title} />
    </div>
    {children}
  </div>
);

const Divider = () => <div style={{ borderTop: "1px solid #f3f4f6", margin: "0.9rem 0" }} />;

const InlineHeading = ({ title }) => (
  <div style={{ fontSize: "13px", fontFamily: '"gilroyBold", Inter, sans-serif', color: "#111827", marginBottom: "0.75rem" }}>
    {title}
  </div>
);

const dropStyle = {
  fontSize: "12px", padding: "4px 10px", borderRadius: "8px",
  border: "1px solid #e5e7eb", background: "#f9fafb",
  color: "#374151", cursor: "pointer", outline: "none",
};

const twoColGrid = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
  gap: "0.9rem", alignItems: "stretch",
};

const blockWrap = { minWidth: 0 };

/* ═══════════════════════════════════════════════════════════════════
   HELPERS
═══════════════════════════════════════════════════════════════════ */
const normalizeNumber = (value) => {
  if (value === null || value === undefined) return 0;
  if (typeof value === "string") {
    const num = Number(value.replace(/,/g, "").trim());
    return Number.isFinite(num) ? num : 0;
  }
  const num = Number(value);
  return Number.isFinite(num) ? num : 0;
};

const pickFirstObject = (source, keys) => {
  for (const key of keys) {
    const value = source?.[key];
    if (value && typeof value === "object" && !Array.isArray(value)) return value;
  }
  return {};
};

const MONTH_SHORT = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];

const formatMonthKey = (date) =>
  `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-01`;

const formatWeekKey = (date) =>
  `${MONTH_SHORT[date.getMonth()]} ${String(date.getFullYear()).slice(-2)}-(W${Math.ceil(date.getDate() / 7)})`;

const parseDateKey = (k) => {
  const str = String(k || "");
  const ymMatch = str.match(/^(\d{4})-(\d{2})$/);
  if (ymMatch) return { year: Number(ymMatch[1]), month: Number(ymMatch[2]) - 1 };
  const ymdMatch = str.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (ymdMatch) return { year: Number(ymdMatch[1]), month: Number(ymdMatch[2]) - 1 };
  const shortMatch = str.match(/^([A-Za-z]{3})\s(\d{2})$/);
  if (shortMatch) return { year: 2000 + Number(shortMatch[2]), month: MONTH_SHORT.indexOf(shortMatch[1]) };
  return null;
};

const aggregateBidSeriesByCreatedDate = (rows = []) => {
  const monthlyMap = {}, weeklyMap = {};
  rows.forEach((row) => {
    const rawDate = row?.created_date || row?.created_at || row?.created_on;
    const d = rawDate ? new Date(rawDate) : null;
    if (!d || Number.isNaN(d.getTime())) return;
    const mk = formatMonthKey(d);
    const wk = formatWeekKey(d);
    monthlyMap[mk] = (monthlyMap[mk] || 0) + 1;
    weeklyMap[wk] = (weeklyMap[wk] || 0) + 1;
  });
  const monthlyLabels = Object.keys(monthlyMap).sort((a, b) => new Date(a) - new Date(b));
  const weeklyLabels = Object.keys(weeklyMap).sort((a, b) => {
    const pa = String(a).match(/^([A-Za-z]{3})\s(\d{2})-\(W(\d)\)$/);
    const pb = String(b).match(/^([A-Za-z]{3})\s(\d{2})-\(W(\d)\)$/);
    if (!pa || !pb) return String(a).localeCompare(String(b));
    const yd = Number(pa[2]) - Number(pb[2]); if (yd) return yd;
    const md = MONTH_SHORT.indexOf(pa[1]) - MONTH_SHORT.indexOf(pb[1]); if (md) return md;
    return Number(pa[3]) - Number(pb[3]);
  });
  return {
    monthlyLabels,
    monthlyValues: monthlyLabels.map((l) => monthlyMap[l] || 0),
    weeklyLabels,
    weeklyValues: weeklyLabels.map((l) => weeklyMap[l] || 0),
  };
};

const toShortMonthLabel = (dateStr) => {
  const p = parseDateKey(dateStr);
  if (!p) return dateStr;
  return `${MONTH_SHORT[p.month]} ${String(p.year).slice(-2)}`;
};

const padSinglePoint = ({ labels, values }) => {
  const formatted = labels.map(toShortMonthLabel);
  if (formatted.length === 1) {
    const p = parseDateKey(labels[0]);
    if (p) {
      const pm = p.month === 0 ? 11 : p.month - 1;
      const py = p.month === 0 ? p.year - 1 : p.year;
      return {
        labels: [`${MONTH_SHORT[pm]} ${String(py).slice(-2)}`, ...formatted],
        values: [0, ...values],
      };
    }
  }
  return { labels: formatted, values: [...values] };
};

const filterMonthly = (labels, values, year, month) => {
  const fl = [], fv = [];
  (labels || []).forEach((l, i) => {
    const p = parseDateKey(l);
    if (!p || p.year !== Number(year)) return;
    if (month !== "all" && p.month !== Number(month)) return;
    fl.push(l);
    fv.push((values || [])[i] ?? 0);
  });
  return { labels: fl, values: fv };
};

const monthOptions = [
  { label: "All Months", value: "all" },
  { label: "January", value: 0 }, { label: "February", value: 1 },
  { label: "March", value: 2 }, { label: "April", value: 3 },
  { label: "May", value: 4 }, { label: "June", value: 5 },
  { label: "July", value: 6 }, { label: "August", value: 7 },
  { label: "September", value: 8 }, { label: "October", value: 9 },
  { label: "November", value: 10 }, { label: "December", value: 11 },
];

/* ═══════════════════════════════════════════════════════════════════
   ISOLATED CHART COMPONENTS
   Each component has its OWN useState for year/month.
   React guarantees state in one component never affects another.
═══════════════════════════════════════════════════════════════════ */

const RFQLineChart = React.memo(({ rawLabels, rawValues, chartDataSet, loadingState }) => {
  const [year, setYear] = useState(new Date().getFullYear());
  const [month, setMonth] = useState("all");

  const yearOptions = useMemo(() => {
    const y = new Set();
    rawLabels.forEach(l => { const p = parseDateKey(l); if (p) y.add(p.year); });
    const s = Array.from(y).sort((a, b) => a - b);
    return s.length ? s : [new Date().getFullYear()];
  }, [rawLabels]);

  useEffect(() => {
    if (yearOptions.length && !yearOptions.includes(Number(year))) {
      setYear(yearOptions[yearOptions.length - 1]);
    }
  }, [yearOptions]);

  const filtered = useMemo(
    () => filterMonthly(rawLabels, rawValues, year, month),
    [rawLabels, rawValues, year, month]
  );

  const { labels, values } = padSinglePoint(filtered);

  return (
    <>
      <div
        style={{ display: "flex", justifyContent: "flex-end", marginBottom: 8, gap: 8 }}
        onClick={(e) => e.stopPropagation()}
      >
        <select value={year} onChange={(e) => setYear(Number(e.target.value))} style={dropStyle}>
          {yearOptions.map((y) => <option key={y} value={y}>{y}</option>)}
        </select>
        <select
          value={month}
          onChange={(e) => setMonth(e.target.value === "all" ? "all" : Number(e.target.value))}
          style={dropStyle}
        >
          {monthOptions.map((m) => <option key={m.value} value={m.value}>{m.label}</option>)}
        </select>
      </div>
      <LineChart
        inline
        dataLabel={labels}
        dataValues={values}
        chartHeight={180}
        chartDataSet={chartDataSet}
        loadingState={loadingState}
        durationValue="weekly"
        disableDuration={true}
      />
    </>
  );
});

const SOLineChart = React.memo(({ rawLabels, rawValues, chartDataSet, loadingState }) => {
  const [year, setYear] = useState(new Date().getFullYear());
  const [month, setMonth] = useState("all");

  const yearOptions = useMemo(() => {
    const y = new Set();
    rawLabels.forEach(l => { const p = parseDateKey(l); if (p) y.add(p.year); });
    const s = Array.from(y).sort((a, b) => a - b);
    return s.length ? s : [new Date().getFullYear()];
  }, [rawLabels]);

  useEffect(() => {
    if (yearOptions.length && !yearOptions.includes(Number(year))) {
      setYear(yearOptions[yearOptions.length - 1]);
    }
  }, [yearOptions]);

  const filtered = useMemo(
    () => filterMonthly(rawLabels, rawValues, year, month),
    [rawLabels, rawValues, year, month]
  );

  const { labels, values } = padSinglePoint(filtered);

  return (
    <>
      <div
        style={{ display: "flex", justifyContent: "flex-end", marginBottom: 8, gap: 8 }}
        onClick={(e) => e.stopPropagation()}
      >
        <select value={year} onChange={(e) => setYear(Number(e.target.value))} style={dropStyle}>
          {yearOptions.map((y) => <option key={y} value={y}>{y}</option>)}
        </select>
        <select
          value={month}
          onChange={(e) => setMonth(e.target.value === "all" ? "all" : Number(e.target.value))}
          style={dropStyle}
        >
          {monthOptions.map((m) => <option key={m.value} value={m.value}>{m.label}</option>)}
        </select>
      </div>
      <LineChart
        inline
        dataLabel={labels}
        dataValues={values}
        chartHeight={180}
        chartDataSet={chartDataSet}
        vendorChart={true}
        loadingState={loadingState}
        durationValue="weekly"
        disableDuration={true}
      />
    </>
  );
});

/* ═══════════════════════════════════════════════════════════════════
   MAIN COMPONENT
═══════════════════════════════════════════════════════════════════ */
const VendorAdminDashboardTab = () => {
  const data = useSelector((state) => state.loginData.value);
  const navigate = useNavigate();
  const vc = DASHBOARD_CHART_PALETTES.vendorDashboard;

  const [auth_token] = useState(data?.auth_token);
  const [vendor_token] = useState(data?.user?.token);
  const vendorInvoiceToken = data?.user?.user_token;

  const [loadingState, setLoadingState] = useState(false);
  const [vendorUserCount, setVendorUserCount] = useState(0);

  const [buyerList, setBuyersList] = useState({ values: { tokens: [], visibleOption: [] } });
  const [customerList, setCustomerList] = useState({ values: { tokens: [], visibleOption: [] } });
  const [itemList, setItemList] = useState({ values: { tokens: [], visibleOption: [] } });
  const [buyerDetails, setBuyerDetails] = useState({ buyerName: "", buyerID: "" });
  const [customerDetails, setCustomerDetails] = useState({ buyerName: "", buyerID: "" });
  const [itemCode, setItemCode] = useState({ item_code: "", item_token: "" });
  const [duration, setDuration] = useState();
  const [fromDate, setFromDate] = useState({ value: "", isValid: true });
  const [toDate, setToDate] = useState({ value: "", isValid: true });

  // Completely separate raw data for each chart
  const [rfqRawData, setRfqRawData] = useState({ labels: [], values: [] });
  const [soRawData, setSoRawData] = useState({ labels: [], values: [] });

  const [analyticsData, setAnalyticsData] = useState({
    totalPrice: "",
    totalRFQCount: "",
    totalBidsCount: "",
    confirmedOrders: "",
    invoiceGeneratedCount: 0,
    pendingVsCloseRFQ: [],
    submittedVsSelectedRFQ: [],
    barChartLabels: [],
    barChartValues: [],
  });

  const [actualBidSeries, setActualBidSeries] = useState({
    monthlyLabels: [], monthlyValues: [],
    weeklyLabels: [], weeklyValues: [],
  });

  useEffect(() => {
    getAllItems();
    getAllBuyersData();
    getAnalyticsValues();
    getVendorUserCount();
    getInvoiceGeneratedCount();
  }, []);

  useEffect(() => { getVendorBidChartSeries(); }, [auth_token, vendor_token]);

  /* ── API calls ── */
  const getAnalyticsValues = async () => {
    const formData = new FormData();
    if (customerDetails.buyerID?.length) formData.append("buyer_token", customerDetails.buyerID);
    else if (buyerDetails.buyerID?.length) formData.append("buyer_company_token", buyerDetails.buyerID);
    formData.append("vendor_token", vendor_token);
    if (itemCode.item_token?.length) formData.append("item_token", itemCode.item_token);
    if (duration) formData.append("month_period", duration);
    if (fromDate.value && !duration) formData.append("from_date", fromDate.value);
    if (toDate.value && !duration) formData.append("to_date", toDate.value);

    setLoadingState(true);
    await axios({
      method: "POST", url: `${API_ENDPOINT.new_vendor_dashbord}`,
      data: formData, headers: { Authorization: `Bearer ${auth_token}` },
    })
      .then((res) => {
        setLoadingState(false);
        const rd = res?.data;

        const bidMonthlyRaw = pickFirstObject(rd, [
          "bid monthly count", "bids monthly count",
          "submitted bid monthly count", "submitted bids monthly count",
          "total bids monthly count", "bid_monthly_count", "bids_monthly_count",
          "submitted_bid_monthly_count", "submitted_bids_monthly_count",
        ]);
        const rfqMonthlyRaw = pickFirstObject(rd, ["rfq monthly count", "rfq_monthly_count"]);
        const salesOrderMonthlyRaw = pickFirstObject(rd, ["total_sales_order", "po monthly count", "po_monthly_count"]);

        // RFQ raw data — stored in its own state, never mixed with SO
        const rfqSource = Object.keys(bidMonthlyRaw).length ? bidMonthlyRaw : rfqMonthlyRaw;
        setRfqRawData({
          labels: Object.keys(rfqSource),
          values: Object.values(rfqSource).map(normalizeNumber),
        });

        // SO raw data — stored in its own state, never mixed with RFQ
        setSoRawData({
          labels: Object.keys(salesOrderMonthlyRaw),
          values: Object.values(salesOrderMonthlyRaw).map(normalizeNumber),
        });

        setAnalyticsData({
          totalPrice: rd?.["total price"],
          totalRFQCount: rd?.["Total RFQ count"],
          totalBidsCount: rd?.["total bids count"],
          confirmedOrders: rd?.["Confirmed Orders"],
          invoiceGeneratedCount: normalizeNumber(
            rd?.["invoice generated count"] ?? rd?.["invoice count"] ??
            rd?.["invoice_generated_count"] ?? rd?.["total invoice count"] ??
            rd?.["invoices generated"] ?? 0
          ),
          pendingVsCloseRFQ: rd ? Object.values(rd["pending and closed rfq"]) : [],
          submittedVsSelectedRFQ: rd ? Object.values(rd["submitted vs selected bid"]) : [],
          barChartLabels: Object.keys(rfqSource),
          barChartValues: Object.values(rfqSource).map(normalizeNumber),
        });
      })
      .catch((err) => { setLoadingState(false); console.log(err); });
  };

  const getInvoiceGeneratedCount = async () => {
    if (!vendorInvoiceToken) return;
    try {
      const res = await axios.post(API_ENDPOINT.get_vendor_invoices, { vendor_token: vendorInvoiceToken });
      const invoices = Array.isArray(res?.data?.invoices) ? res.data.invoices : [];
      setAnalyticsData((prev) => ({ ...prev, invoiceGeneratedCount: invoices.length }));
    } catch (err) { console.log("get_vendor_invoices", err); }
  };

  const getVendorBidChartSeries = async () => {
    if (!auth_token || !vendor_token) return;
    try {
      const fd1 = new FormData();
      fd1.append("page", 1); fd1.append("vendor_token", vendor_token);
      const firstRes = await axios({ method: "POST", url: API_ENDPOINT.get_all_vendor_RFQ, data: fd1, headers: { Authorization: `Bearer ${auth_token}` } });
      const firstResults = Array.isArray(firstRes?.data?.results) ? firstRes.data.results : [];
      const totalCount = Number(firstRes?.data?.page_count || firstResults.length || 0);
      const perPage = Math.max(Number(firstRes?.data?.current_page_count || firstResults.length || 1), 1);
      const totalPages = Math.max(Math.ceil(totalCount / perPage), 1);
      let allResults = [...firstResults];
      for (let page = 2; page <= totalPages; page++) {
        const fd = new FormData(); fd.append("page", page); fd.append("vendor_token", vendor_token);
        const pageRes = await axios({ method: "POST", url: API_ENDPOINT.get_all_vendor_RFQ, data: fd, headers: { Authorization: `Bearer ${auth_token}` } });
        allResults = allResults.concat(Array.isArray(pageRes?.data?.results) ? pageRes.data.results : []);
      }
      setActualBidSeries(aggregateBidSeriesByCreatedDate(allResults));
    } catch (err) {
      console.log("getVendorBidChartSeries", err);
      setActualBidSeries({ monthlyLabels: [], monthlyValues: [], weeklyLabels: [], weeklyValues: [] });
    }
  };

  const getVendorUserCount = async () => {
    if (!auth_token || !vendor_token) return;
    const fd = new FormData(); fd.append("page", 1); fd.append("vendor_token", vendor_token);
    await axios({ method: "POST", url: `${API_ENDPOINT.get_vendor_contacts}`, data: fd, headers: { Authorization: `Bearer ${auth_token}` } })
      .then((res) => setVendorUserCount(Number(res?.data?.total_count || res?.data?.total_items || res?.data?.count || res?.data?.results?.length || 0)))
      .catch((err) => { console.log(err); setVendorUserCount(0); });
  };

  const getAllBuyersData = async () => {
    await axios({ method: "POST", url: `${API_ENDPOINT.getBuyerList}`, data: { vendor_token }, headers: { Authorization: `Bearer ${auth_token}` } })
      .then((res) => {
        const arr = Array.isArray(res?.data?.response) ? res.data.response : [];
        const unique = Array.from(new Set(arr.map(i => i.company_name))).map(cn => arr.find(i => i.company_name === cn));
        setBuyersList({ values: { tokens: unique.map(e => e?.token), visibleOption: [...new Set(arr.map(e => e?.company_name + ""))] } });
      })
      .catch(() => setBuyersList({ values: { tokens: [null], visibleOption: ["No options"] } }));
  };

  const getAllItems = async () => {
    await axios({ method: "POST", url: `${API_ENDPOINT.getItemCodes}`, data: { vendor_token }, headers: { Authorization: `Bearer ${auth_token} ` } })
      .then((res) => setItemList({ values: { tokens: res?.data?.response?.map(e => e?.token), visibleOption: res?.data?.response?.map(e => e?.item_code) } }))
      .catch(() => setItemList({ values: { tokens: [null], visibleOption: ["No options"] } }));
  };

  const resetSearch = () => {
    setCustomerDetails({ buyerName: "", buyerID: "" });
    setCustomerList({ values: { tokens: [], visibleOption: [] } });
    setTimeout(() => { const el = document.getElementById("customerName"); if (el) el.value = ""; }, 200);
  };

  const getCustomerName = async (companyToken) => {
    resetSearch();
    if (!companyToken || !companyToken.length) return;
    await axios({ method: "POST", url: `${API_ENDPOINT.vendor_customer_list}`, data: { buyer_token: companyToken, vendor_token }, headers: { Authorization: `Bearer ${auth_token} ` } })
      .then((res) => {
        resetSearch();
        const cl = res.data.response;
        const unique = Array.isArray(cl) ? Array.from(new Set(cl.map(i => i.full_name))).map(fn => cl.find(i => i.full_name === fn)) : [];
        setCustomerList({ values: { tokens: unique.map(e => e?.token), visibleOption: [...new Set(cl?.map(e => e?.full_name + ""))] } });
      })
      .catch(() => setCustomerList({ values: { tokens: [null], visibleOption: ["No options"] } }));
  };

  const validateFilters = () => {
    const f = emptyCheck(fromDate?.value), t = emptyCheck(toDate?.value);
    setFromDate(p => ({ ...p, isValid: f }));
    setToDate(p => ({ ...p, isValid: t }));
    return f && t;
  };

  const handleFilterSearch = () => { if (!duration ? validateFilters() : true) getAnalyticsValues(); };

  // Prefer paginated actual bid series for RFQ chart, fall back to API summary
  const rfqFinalLabels = actualBidSeries.monthlyLabels.length ? actualBidSeries.monthlyLabels : rfqRawData.labels;
  const rfqFinalValues = actualBidSeries.monthlyValues.length ? actualBidSeries.monthlyValues : rfqRawData.values;

  const submittedAndSelectedBidDataValue = analyticsData.submittedVsSelectedRFQ || [0, 0, 0];
  const pendingAndClosedRFQDataValues = analyticsData.pendingVsCloseRFQ || [0, 0];
  const invoiceProcessCount = normalizeNumber(analyticsData.invoiceGeneratedCount);

  const centreText = (t, v) => (
    <span style={{ fontSize: "13px", fontFamily: '"gilroyBold",Inter,sans-serif', color: "#111827", lineHeight: 1.3 }}>
      {t}<br />{v}
    </span>
  );

  const rfqBidDataSet = useMemo(() => ({
    cardHeading: "Submitted and Selected Bid",
    chartText: centreText("Bids", submittedAndSelectedBidDataValue[0] || 0),
    chartLabels: ["Submitted", "Selected", "Unsubmitted"],
    barColors: vc.submittedSelected,
    chartIndicators: [
      { value: "Submitted Bid", color: vc.submittedSelected[0] },
      { value: "Selected Bid", color: vc.submittedSelected[1] },
      { value: "Unsubmitted RFQ", color: vc.submittedSelected[2] },
    ],
    indicatorPlacement: "below", indicatorColumns: 2,
    onSegmentClick: () => navigate("/Vendor_dashboard/RFQ"),
  }), [vc.submittedSelected, submittedAndSelectedBidDataValue, navigate]);

  const pendingClosedDataSet = useMemo(() => ({
    cardHeading: "Pending and Closed RFQ",
    cardHeadingStyle: { fontSize: "14px", fontFamily: '"gilroyMedium", Inter, sans-serif', color: "#111827" },
    chartText: centreText("Total Sourcing Events", pendingAndClosedRFQDataValues[0] + pendingAndClosedRFQDataValues[1]),
    chartLabels: ["RFQs Awaiting Action", "Completed Sourcing Events"],
    barColors: vc.pendingClosedRfq,
    chartIndicators: [
      { value: "Pending", color: vc.pendingClosedRfq[0] },
      { value: "Closed", color: vc.pendingClosedRfq[1] },
    ],
    indicatorPlacement: "below", indicatorColumns: 1,
  }), [vc.pendingClosedRfq, pendingAndClosedRFQDataValues]);

  const rfqLineDataSet = useMemo(() => ({
    cardHeading: "Total Bids Submitted",
    chartLabels: ["Bids Submitted"],
    chartIndicators: [{ value: "Bids Submitted", color: vc.totalBidsSubmitted?.[0] || "#2ecc71" }],
    barColor: vc.totalBidsSubmitted,
  }), [vc.totalBidsSubmitted]);

  const soLineDataSet = useMemo(() => ({
    cardHeading: "Total Sales Order",
    chartLabels: ["Sales Order"],
    chartIndicators: [{ value: "Sales Order", color: vc.totalSalesOrder?.[0] || "#3b82f6" }],
    barColor: vc.totalSalesOrder,
  }), [vc.totalSalesOrder]);

  const durationList = ["last month", "last 3 months", "last 6 months"];

  const reportCardData = [
    { cardName: "Total Sales Order", cardImg: totalPOIMg, cardValue: `Rs.${analyticsData?.totalPrice ?? 0}` },
    {
      cardName: "Total Sourcing Events",
      cardImg: totalPOIMg2,
      cardValue: `${analyticsData?.totalRFQCount ?? 0}`,
      onClick: () => navigate("/Vendor_dashboard/RFQ"),
    },
    {
      cardName: "Total Bids",
      cardImg: totalPOIMg3,
      cardValue: `${analyticsData?.totalBidsCount ?? 0}`,
      onClick: () => navigate("/Vendor_dashboard/RFQ"),
    },
    {
      cardName: "Confirm Orders",
      cardImg: totalPOIMg4,
      cardValue: `${analyticsData?.confirmedOrders ?? 0}`,
      onClick: () => navigate("/Vendor_dashboard/PO"),
    },
    {
      cardName: "Invoices Generated",
      cardImg: totalPOIMg4,
      cardValue: `${invoiceProcessCount || 0}`,
      onClick: () => navigate("/Vendor_dashboard/InvoiceProcess"),
    },
    {
      cardName: "Supplier Users",
      cardImg: userIcon,
      cardValue: `${Number(vendorUserCount) || 0}`,
      onClick: () => navigate("/Vendor_dashboard/Users"),
    },
  ];

  return (
    <div className={classes.dashboardPage}>

      <div className={classes.pageSectionPad}>
        <HeaderTitle titleText="Supplier Admin Dashboard" />
      </div>

      <div className={classes.pageSectionPadTop}>
        <div className={`${classes.filters} ${classes.flex}`}>
          <DSelectInput options={buyerList.values} getIDValue={true} customClass={classes.filterFields} label="Customer Company Name"
            setIDValue={(e) => { setBuyerDetails(p => ({ ...p, buyerID: e })); getCustomerName(e); }}
            onChange={(e) => setBuyerDetails(p => ({ ...p, buyerName: e }))} />
          <DSelectInput id="customerName" options={customerList.values} getIDValue={true} customClass={classes.filterFields} label="Customer Name"
            disabled={!buyerDetails?.buyerID?.length}
            setIDValue={(e) => setCustomerDetails(p => ({ ...p, buyerID: e }))}
            onChange={(e) => setCustomerDetails(p => ({ ...p, buyerName: e }))} />
          <DSelectInput options={itemList.values} customClass={classes.filterFields} getIDValue={true} label="Item Code"
            setIDValue={(e) => setItemCode(p => ({ ...p, item_token: e }))}
            onChange={(e) => setItemCode(p => ({ ...p, item_code: e }))} />
          <DSelectInput options={durationList} customClass={classes.filterFields} label="Duration"
            onChange={(e) => { setDuration(e); setFromDate({ value: "", isValid: true }); setToDate({ value: "", isValid: true }); }} />
          <DDateInput customClass={classes.filterFields} type="date" label="Start Date" disableFuture={true}
            onChange={(e) => setFromDate({ isValid: emptyCheck(e), value: e })}
            disabledInput={duration} value={fromDate} error={!fromDate?.isValid} errorMsg="From date is required" />
          <div className={`${classes.flex} ${classes.filterSearch}`}>
            <DDateInput customClass={classes.filterFields} type="date" label="End Date" disableFuture={true}
              onChange={(e) => setToDate({ isValid: emptyCheck(e), value: e })}
              disabledInput={duration} value={toDate} error={!toDate?.isValid} errorMsg="To date is required" />
            <DButton vendorBtn={true} labelImg={btnImg} customWrapperClass={classes.filterBtn}
              customClass={classes.button} iconWidth="2rem" iconHeight="2rem" onClick={handleFilterSearch} />
          </div>
        </div>
      </div>

      <div className={classes.pageSectionPadMain}>
        <div className={classes.dashboardGroup}>

          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))", gap: "1.25rem", marginBottom: "1.75rem", alignItems: "stretch" }}>
            {reportCardData.map((e, i) => (
              <div
                key={i}
                style={{
                  height: "100%",
                  display: "flex",
                  cursor: typeof e.onClick === "function" ? "pointer" : "default",
                }}
                role={typeof e.onClick === "function" ? "button" : undefined}
                tabIndex={typeof e.onClick === "function" ? 0 : undefined}
                onClick={typeof e.onClick === "function" ? e.onClick : undefined}
                onKeyDown={
                  typeof e.onClick === "function"
                    ? (evt) => {
                        if (evt.key === "Enter" || evt.key === " ") {
                          evt.preventDefault();
                          e.onClick();
                        }
                      }
                    : undefined
                }
              >
                <Reportcard index={i} title={e.cardName} value={e.cardValue} reportImg={e.cardImg} loadingState={loadingState} />
              </div>
            ))}
          </div>

          <div className={`${classes.twoColResponsive} ${classes.rowGap}`}>

            {/* LEFT: RFQ — RFQLineChart is a separate component with its own state */}
            <SectionCard title="RFQ Summary">
              <div style={{ ...blockWrap, cursor: "pointer" }} onClick={() => navigate("/Vendor_dashboard/RFQ")}>
                <RFQLineChart
                  rawLabels={rfqFinalLabels}
                  rawValues={rfqFinalValues}
                  chartDataSet={rfqLineDataSet}
                  loadingState={loadingState}
                />
              </div>
              <Divider />
              <div style={{ ...twoColGrid, gridTemplateColumns: "repeat(2, minmax(0, 1fr))" }}>
                <div style={blockWrap}>
                  <div onClick={() => navigate("/Vendor_dashboard/RFQ")} style={{ cursor: "pointer" }}>
                    <DonutChart inline chartValues={submittedAndSelectedBidDataValue} chartDataSet={rfqBidDataSet} loadingState={loadingState} />
                  </div>
                </div>
                <div style={blockWrap}>
                  <div onClick={() => navigate("/Vendor_dashboard/RFQ")} style={{ cursor: "pointer" }}>
                    <DonutChart inline chartValues={pendingAndClosedRFQDataValues} chartDataSet={pendingClosedDataSet} loadingState={loadingState} />
                  </div>
                </div>
              </div>
            </SectionCard>

            {/* RIGHT: SO — SOLineChart is a separate component with its own state */}
            <SectionCard title="Sales Order Summary">
              <div style={{ ...blockWrap, cursor: "pointer" }} onClick={() => navigate("/Vendor_dashboard/RFQ")}>
                <SOLineChart
                  rawLabels={soRawData.labels}
                  rawValues={soRawData.values}
                  chartDataSet={soLineDataSet}
                  loadingState={loadingState}
                />
              </div>
              <Divider />
              <div style={blockWrap}>
                <InlineHeading title="Sales Order Trend" />
                <div onClick={() => navigate("/Vendor_dashboard/RFQ")} style={{ cursor: "pointer" }}>
                  <BarChart
                    inline
                    labels={analyticsData.barChartLabels}
                    mainData={analyticsData.barChartValues}
                    vendorDashboard={true}
                    chartDataSet={{
                      cardHeading: "",
                      chartIndicators: [{ value: "Total Bids", color: vc.totalBidsSubmitted?.[0] || "#2ecc71" }],
                      barColors: vc.totalBidsSubmitted,
                    }}
                    loadingState={loadingState}
                    durationValue="monthly"
                  />
                </div>
              </div>
            </SectionCard>

          </div>
        </div>
      </div>
    </div>
  );
};

export default VendorAdminDashboardTab;
